




















































































































































































































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { VForm } from "@/common/vuetify_types";
import { dateFormat } from "@/common/date_format";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import { checkSelfRole, isSuperAdmin, selfData } from "@/common/role_utils";
import { maxFileSize, requiredString } from "@/tool/validation";
import moment from "moment";
import { ListedEmployee } from "@/api";

@Component({
  components: {
    VuePdfApp,
  },
})
export default class UploadDoc extends Vue {
  @Ref("form") readonly form!: VForm;
  @Prop() readonly multipleProp!: boolean;
  @Prop() readonly url!: string;
  @Prop() readonly name!: string;
  @Prop() readonly id!: number;
  @Prop() readonly capture!: File;

  fileURL: string | ArrayBuffer | null | undefined = this.url || "";
  formModel = false;
  datePicker = false;
  documentName = this.name;
  expirationDate = "";
  isCompany = this.$route.path.includes("company");

  get isSuperAdmin(): boolean {
    return isSuperAdmin();
  }

  get isOwner(): boolean {
    return checkSelfRole("owner") || this.isSuperAdmin;
  }
  formattedExpirationDate = "";
  license = "";
  dateError: null | string = null;
  rules = {
    required: requiredString,
    dateRequired: (v: string) => v !== "" && v !== undefined,
  };
  isPDF = false;
  config = {
    toolbar: false,
  };
  dragover = false;
  uploadedFiles: File[] = this.capture ? [this.capture] : [];
  multiple = this.multipleProp ? true : false;
  fileData: FormData | null = null;
  uploading = false;
  fileError = "";
  isExpiration = false;
  minDate = moment()
    .local()
    .format("YYYY-MM-DD");
  employeeID = 0;

  formatDate(date: string) {
    this.formattedExpirationDate = dateFormat(date);
  }

  removeFile(fileName: string) {
    const index = this.uploadedFiles.findIndex(
      (file: File) => file.name === fileName,
    );
    // If file is in uploaded files remove it
    if (index > -1) this.uploadedFiles.splice(index, 1);
    this.fileURL = "";
  }

  closeDialog(upload: boolean) {
    this.$emit("close", upload);
  }

  submitDoc() {
    this.closeDialog(true);
  }

  checkFileSize(file: File) {
    const validSize = maxFileSize(file, 5);
    if (typeof validSize === "string") {
      this.fileError = validSize;
      return true;
    }
    return false;
  }

  onDrop(e: { dataTransfer: { files: File[] } }) {
    this.dragover = false;
    if (this.uploadedFiles.length > 0) this.uploadedFiles = [];
    if (!this.multiple && e.dataTransfer.files.length > 0) {
      if (this.checkFileSize(e.dataTransfer.files[0])) return;
      this.uploadedFiles.push(e.dataTransfer.files[0]);
    } else
      e.dataTransfer.files.forEach(element => this.uploadedFiles.push(element));
    this.formDataURL();
  }

  onChangeFile(event: { target: { files: never[] } }) {
    this.dragover = false;
    if (this.uploadedFiles.length > 0) this.uploadedFiles = [];
    if (!this.multiple && event.target.files.length > 0) {
      if (this.checkFileSize(event.target.files[0])) return;
      this.uploadedFiles.push(event.target.files[0]);
    } else
      event.target.files.forEach(element => this.uploadedFiles.push(element));
    this.formDataURL();
  }

  formDataURL() {
    const reader = new FileReader();
    if (this.uploadedFiles.length) {
      reader.onload = (event: ProgressEvent<FileReader>) => {
        this.fileURL = event.target?.result;
      };
      reader.readAsDataURL(this.uploadedFiles[0]);
    }
    this.isPDF =
      this.uploadedFiles[0].type === "application/pdf" ? true : false;
  }

  async submit() {
    this.dateError = null;
    const uploadLen = () => {
      if (this.uploadedFiles.length === 0) {
        this.fileError = "File required";
        return true;
      }
      return false;
    };
    const checkExpirationDate = () => {
      if (this.isExpiration) {
        this.expirationDate = "";
        return false;
      }
      if (!this.rules.dateRequired(this.expirationDate)) {
        this.dateError = "Required";
        return true;
      }
      return false;
    };
    if (!this.form.validate() || checkExpirationDate()) {
      uploadLen();
      return;
    }
    if (uploadLen()) return;
    const formData = new FormData();
    formData.append(
      "document",
      this.uploadedFiles[0],
      this.uploadedFiles[0]?.name,
    );
    try {
      this.uploading = true;
      if (this.isCompany && this.isOwner) {
        const payload: {
          employeeId: number;
          documentId: number;
          expirationDate?: string;
          license?: string;
          // eslint-disable-next-line
          requestBody: FormData;
        } = {
          employeeId:
            this.isOwner && this.isCompany ? this.employeeID : selfData()?.id,
          documentId: this.id,
          expirationDate: this.expirationDate,
          license: this.license, // not send from UI
          requestBody: formData,
        };
        await this.$store.dispatch(
          "employeeDocuments/uploadDocumentByOwner",
          payload,
        );
      } else {
        const payload: {
          employeeId: number;
          departmentDocumentId: number;
          expirationDate?: string;
          license?: string;
          // eslint-disable-next-line
          requestBody: FormData;
          role: string;
        } = {
          employeeId: selfData()?.id,
          departmentDocumentId: this.id,
          expirationDate: this.expirationDate,
          license: this.license,
          requestBody: formData,
          role: selfData()?.roles?.[0] || "",
        };
        await this.$store.dispatch("employeeDocuments/uploadDocument", payload);
      }
      this.uploading = false;
      if (this.isOwner && this.isCompany) {
        await this.$store.dispatch("employeeDocuments/getCompanyDocumentCount");
        this.$store.dispatch("employeeDocuments/getOwnerDocumentList", {
          documentId: this.id,
        });
      } else {
        await this.$store.dispatch("employeeDocuments/getSelfDocumentCount");
        if (this.id.toString() === this.$route.params.documentId) {
          this.fetchDocumentLists();
        } else {
          this.$router.push("/employee-document/" + this.id);
        }
      }
      this.submitDoc();
    } catch (error) {
      this.uploading = false;
      this.$store.dispatch("alert/error", error);
    }
  }

  async fetchDocumentLists() {
    await this.$store.dispatch("employeeDocuments/getDocumentList", {
      departmentDocumentId: this.$route.params.documentId,
    });
  }

  get employees() {
    const emps =
      (this.$store.getters[
        "employeeDocuments/employeeList"
      ] as ListedEmployee[]) || [];
    if (emps?.length > 0) {
      return emps.map(emp => ({
        ...emp,
        name: `${emp.firstName} ${emp.lastName}`,
      }));
    }
    return emps;
  }
}
